"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Space = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const package_1 = require("../package");
const sioc_1 = require("../ontologies/sioc");
const Usergroup_1 = require("./Usergroup");
let Space = class Space extends Shape_1.Shape {
    get usergroups() {
        return this.getAllAs(sioc_1.sioc.has_usergroup, Usergroup_1.Usergroup);
    }
};
exports.Space = Space;
Space.targetClass = sioc_1.sioc.Space;
exports.Space = Space = __decorate([
    package_1.linkedShape
], Space);
//# sourceMappingURL=Space.js.map